import axios from "axios";
const HOST_API = process.env.REACT_APP_MAIN_HOST;

const config = {
  url: {
    HOST_API: HOST_API ?? "https://export.gov.kz/qaztrade/api"
  },
};

export const PUBLIC_URL = process.env.PUBLIC_URL;
console.log(PUBLIC_URL)
export const api = axios.create({ baseURL: config.url.HOST_API });
